<template>
    <ui-dropdown placement="bottom-start" menu-class="w-full max-w-lg">
        <template #default="dropdownScope">
            <slot v-bind="scope(dropdownScope)"></slot>
        </template>

        <template #menu="{ close }">
            <div class="p-3 max-h-64 overflow-y-auto">

                <!-- Empty State. -->
                <div v-if="!query" class="text-gray-500 text-sm">
                    <span v-if="loaded">Start typing to search for known contact...</span>
                    <span v-else>Contact library is still loading from server...</span>

                </div>

                <div v-else class="space-y-6">
                    <div v-if="filteredContacts.length > 0">
                        <div class="ml-2 text-xs font-medium text-gray-400 mb-1">Known Contacts</div>
                        <div class="space-y-1">
                            <button
                                v-for="contact in filteredContacts"
                                class="flex items-center space-x-2 text-left w-full rounded-md px-2 py-1 focus:outline-none focus:ring-2 focus:ring-blue-600"
                                :title="contact.name"
                                @click="selectContact(contact, close)"
                            >
                                <div class="truncate flex-1 flex flex-col">
                                    <div class="truncate w-full">{{ contact.name }}</div>
                                    <div class="truncate w-full text-xs text-gray-500" v-if="contact.phone">
                                        {{ contact.phone }}
                                    </div>
                                    <div class="truncate w-full text-xs text-gray-500" v-if="contact.phone2">
                                        {{ contact.phone2 }}
                                    </div>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div v-else class="text-gray-500 text-sm">
                        No matching contacts found.
                    </div>

                </div>
            </div>
        </template>
    </ui-dropdown>
</template>

<script>
import {Contact} from '@models'

export default {
    props: {
        top: Boolean,
        buttonClass: {
            type: String,
            default: 'text-left w-full rounded-md px-2 py-1 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-600',
        },
    },
    data() {
        return {
            query: '',
            contacts: [],
            loaded: false,
        }
    },
    computed: {
        filteredContacts() {
            return this.contacts.filter(this.matchContact).sort((a, b) => {
                let score = 0;
                score += a.phone ? 0 : 1;
                score += b.phone ? 0 : -1;
                return score;
            }).slice(0, 100);
        },
    },
    methods: {
        scope(dropdownScope) {
            return {
                query: this.query,
                setQuery: this.setQuery,
                ...dropdownScope
            }
        },
        setQuery(query) {
            this.query = query
            if (!this.query) return
        },
        matchContact(contact) {
            const query = this.query.toLowerCase().split(/[^A-Za-z0-9.-]+/);
            let ret = query.every((token) => {
                return (contact.name + '|' + contact.phone ).toLowerCase().includes(token);
            });
            return ret;
        },
        selectContact(contact, close) {
            this.$emit('selected:contact', contact);
            this.query = contact.name + ' ' + contact.phone;
            close();
        },
    },
    async mounted() {
        this.contacts = await Contact.allWithPhoneNumbers()
        this.loaded = true;
    }
}
</script>
